import React, { useState } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useForm } from '../../../hooks/ useForm';
import { seleccionarPhoto, updateIntroduccion } from '../../../helpers/contenido';
import { useDispatch } from 'react-redux';
import { setIntroDescription, setIntroImagen } from '../../../reducer/ContenidoReducer';
import Loading from '../../tools/Loading';
import ReactHtmlParser from 'react-html-parser'
const Introduccion = ({data, email, idAsig, idTema}) => {
    const dispatch = useDispatch();
    const {id,picture, description} = data;
    const [edit, setEdit] = useState(false)
    const [upDescripcion, setUpDescripcion] = useState(description)
    const [value, handleInputChange] = useForm({imagen: ''});
    const {imagen} = value
    const [loadingDescription, setLoadingDescription] = useState(false)
    const [loadingImagen, setLoadingImagen] = useState(false)

    const handleUpDescripcion = () => {
        setLoadingDescription(true)
        updateIntroduccion(email,idAsig,idTema,id,upDescripcion)
        .then(() => {
            dispatch(setIntroDescription(upDescripcion))
            setLoadingDescription(false)
        })
    }

    const handleUpImagen = () => {
        setLoadingImagen(true)
        seleccionarPhoto(imagen,email,idAsig,idTema,id)
        .then(() => {
            const url = URL.createObjectURL(imagen);
            dispatch(setIntroImagen(url))
            setLoadingImagen(false)
        })
    }

    return (
        <div className='intro'>
            <figure>
                <img src={picture} alt='Imagen Foto' />
            </figure>
            {
                edit 
                && <div className='bts_controls_contenido'>
                        {
                            loadingImagen
                            ? <Loading />
                            :
                                <>
                                    <label htmlFor='up_img' className='fas fa-upload'> </label>
                                    <input type="file" id='up_img' name='imagen' style={{display:'none'}}
                                        onChange={handleInputChange} />
                                    <i className='fas fa-save' onClick={handleUpImagen}></i>
                                </>
                        }
                        
                    </div>
            }
            {
                edit
                ?   
                    <div className='contCk'>
                        <CKEditor key='ckEd'  
                            editor={ClassicEditor} 
                            data={upDescripcion}
                            onChange={(e,editor) => setUpDescripcion(editor.getData())}
                        />
                        {
                            loadingDescription
                            ?   <Loading />
                            :   <button 
                                    className='btn_success'
                                    onClick={handleUpDescripcion}
                                >Guardar</button>
                        }
                        
                    </div>
                :
                    <article>
                        {ReactHtmlParser(description)}
                    </article>
            }
            
            <div className='bts_controls_contenido'>
                {
                    edit
                    ?<button className='btn_danger' onClick={() => setEdit(!edit)}>Salir de la edición</button>
                    :<button className='btn_info'  onClick={() => setEdit(!edit)}>Editar</button>
                }
            </div>
        </div>
    )
}

export default Introduccion
